import createAPIRequest from "../helpers/createAPIRequest";
import handleError from "../helpers/handleError";
import store from "../store/index";

//-------------
// delete slot
//-------------
export default async function useDeleteSlot(parm) {
  // console.log("------------------------");
  // console.log("IN useDeleteSlot");

  let api_call = null;
  let url;
  //--------------
  // access store
  //--------------
  const this_store = store;
  //---------------
  // url = actions
  //---------------
  if (parm.slot == "Action") {
    url = "combat-actions";
    //---------------
    // url = markers
    //---------------
  } else if (parm.slot == "Marker") {
    url = "combat-markers";
    //-----------------
    // url = reactions
    //-----------------
  } else {
    url = "combat-reactions";
  }
  let endpoint = "api/v1/" + url + "/";
  //--------------------
  // set api call parms
  //--------------------
  let request_parms = {
    endpoint: endpoint,
    slug: parm.slug,
    deleteInd: true,
  };
  //--------------------
  // create api request
  //--------------------
  let request = createAPIRequest(request_parms);
  //--------------------------------
  // make store API call (deletion)
  //--------------------------------
  api_call = this_store.dispatch("combat/deleteSlot", request);
  //---------------
  // await results
  //---------------
  await api_call
    //----------
    // where ok
    //----------
    .then(() => {})
    //-------------
    // where error
    //-------------
    .catch((err) => {
      handleError(err,11);
    });
}
